import React from "react";
import ProtectedSwagger from "../components/ProtectedSwagger";
import { services } from "../config/services";

const service = services.find((item) => item.route === "/kyc-sdk-storage");

const KycSdkStorageAPIDoc = () => (
    <ProtectedSwagger
        attachBearerToken={false}
        authLabel="Publico"
        authStatusLabel="Sin autorizacion"
        service={service}
        url={process.env.PUBLIC_URL + "/json/openapi/kyc-sdk-storage-openapi.json"}
    />
);

export default KycSdkStorageAPIDoc;
